import { Flex, Text, Image, Box } from "@chakra-ui/react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useUserContext } from "context/UserContext";
import options, { accountOptions, mainOptions, otherOptions } from "./options";
import { useEffect, useState } from "react";

const RoutesGroup = ({ routes, location }) => {
  const [isOpen, setIsOpen] = useState(
    routes?.sublinks?.some((link) => location.pathname.startsWith(link.url))
      ? true
      : false
  );

  useEffect(() => {
    if (
      routes?.sublinks?.some((link) => location.pathname.startsWith(link.url))
    ) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [location.pathname, routes]);

  if (isOpen) {
    return (
      <Box>
        <Flex
          alignItems={"center"}
          justify={"center"}
          padding={4}
          _hover={{
            cursor: "pointer",
            // backgroundColor: "#456EFF",
          }}
          borderRadius={"16px"}
          onClick={() => setIsOpen((p) => !p)}
        >
          <Image
            src={routes.icon}
            width={"18px"}
            height={"18px"}
            marginRight={3}
          />
          <Text
            fontFamily={"PlusJakartaSansSemiBold"}
            fontSize={"16px"}
            lineHeight={"20px"}
            color={"#FFFFFF"}
            textTransform={"capitalize"}
            flex={1}
          >
            {routes.label}
          </Text>
          <Image
            src={require("assets/svgs/Arrow_drop_down.svg").default}
            width={"18px"}
            height={"18px"}
          />
        </Flex>

        <Flex direction="column" width={"100%"} flex={1} paddingLeft={"20px"}>
          {routes.sublinks.map((route) => (
            <Link key={route.id} to={route.url}>
              <Flex
                alignItems={"center"}
                padding={4}
                bg={
                  location.pathname.startsWith(route.url)
                    ? "#456EFF"
                    : "transparent"
                }
                _hover={{
                  cursor: "pointer",
                  // bg: route.url === location.pathname ? "#456EFF99" : "#456EFF",
                }}
                borderRadius={"16px"}
              >
                {route.activeIcon && (
                  <Image
                    src={
                      location.pathname.startsWith(route.url)
                        ? route.activeIcon
                        : route.inactiveIcon
                    }
                    width={"18px"}
                    height={"18px"}
                    marginRight={3}
                  />
                )}
                <Text
                  fontFamily={"PlusJakartaSansSemiBold"}
                  fontSize={"16px"}
                  letterSpacing={"0.6px"}
                  color={
                    location.pathname.startsWith(route.url)
                      ? "#FFFFFF"
                      : "#FFFFFF"
                  }
                  textTransform={"capitalize"}
                >
                  {route.label}
                </Text>
              </Flex>
            </Link>
          ))}
        </Flex>
      </Box>
    );
  }
  return (
    <Flex
      alignItems={"center"}
      justify={"center"}
      padding={4}
      _hover={{
        cursor: "pointer",
        // backgroundColor: "#456EFF",
      }}
      borderRadius={"16px"}
      onClick={() => setIsOpen((p) => !p)}
    >
      <Image src={routes.icon} width={"18px"} height={"18px"} marginRight={3} />
      <Text
        fontFamily={"PlusJakartaSansSemiBold"}
        fontSize={"16px"}
        lineHeight={"20px"}
        color={"#FFFFFF"}
        textTransform={"capitalize"}
        flex={1}
      >
        {routes.label}
      </Text>
      <Image
        src={require("assets/svgs/Arrow_drop_down.svg").default}
        width={"18px"}
        height={"18px"}
      />
    </Flex>
  );
};

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, signOut } = useUserContext();
  const [currentPage, setCurrentPage] = useState("");

  const handleLogout = () => {
    signOut();
    navigate("/login");
  };

  useEffect(() => {
    const currentURL = location?.pathname;
    setCurrentPage(currentURL);
  }, []);

  const handleNavigation = (url) => {
    navigate(url);
    setCurrentPage(url);
  };

  return (
    <>
      <Flex
        position={"fixed"}
        direction="column"
        alignItems="center"
        alignSelf="stretch"
        paddingTop={12}
        h={"100vh"}
        w={"280px"}
        overflowX={"auto"}
        sx={{
          "::-webkit-scrollbar": {
            display: "none",
          },
        }}
      >
        <Text
          fontFamily={"PlusJakartaSansSemiBold"}
          fontSize={18}
          color={"#000000"}
          textAlign={"center"}
          textTransform={"capitalize"}
        >
          KIDSWEAR COLLECTIVE
        </Text>
        <Text
          fontFamily={"PlusJakartaSansBold"}
          fontSize={12}
          color={"#000000"}
          textAlign={"center"}
          textTransform={"capitalize"}
        >
          SELLER'S PLATFORM
        </Text>

        <Flex
          direction="column"
          bg={"#000000"}
          width={"100%"}
          // height={"100vh"}
          marginTop={8}
          flex={1}
          borderTopRightRadius={"16px"}
          borderTopLeftRadius={"16px"}
          padding={6}
        >
          {/* Main Section */}
          {mainOptions.length > 0 && (
            <>
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"12px"}
                lineHeight={"16px"}
                color={"#FFFFFF"}
                textTransform={"capitalize"}
                mb={3}
                padding={4}
                padddingTop={0}
              >
                main
              </Text>
              {mainOptions.map((option) => (
                <>
                  <Flex
                    key={option.id}
                    onClick={() => handleNavigation(option.url)}
                    alignItems={"center"}
                    borderRadius={"16px"}
                    padding={4}
                    bg={option.url === currentPage ? "#456EFF" : "transparent"}
                    _hover={{
                      cursor: "pointer",
                      bg:
                        option.url === currentPage ? "#456EFF" : "transparent",
                    }}
                  >
                    <Image
                      src={
                        option.url == currentPage
                          ? option.activeIcon
                          : option.inactiveIcon
                      }
                      width={"18px"}
                      height={"18px"}
                      marginRight={3}
                    />
                    <Text
                      fontFamily={"PlusJakartaSansSemiBold"}
                      fontSize={"16px"}
                      lineHeight={"20px"}
                      color={option.url === currentPage ? "#FFFFFF" : "#FFFFFF"}
                      textTransform={"capitalize"}
                    >
                      {option.label}
                    </Text>
                  </Flex>
                </>
              ))}
            </>
          )}
          {/* Others Section */}
          <Box
            height="1px"
            bg="#FFFFFF"
            opacity={0.3}
            marginY={4}
            marginX={2}
          />
          {otherOptions.length > 0 && (
            <>
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"12px"}
                lineHeight={"16px"}
                color={"#FFFFFF"}
                textTransform={"capitalize"}
                mb={2}
                padding={4}
              >
                Others
              </Text>
              {otherOptions.map((option) =>
                option.isLinkGroup ? (
                  <RoutesGroup
                    key={option}
                    routes={option}
                    location={location}
                  />
                ) : (
                  <>
                    <Flex
                      key={option.id}
                      onClick={() => handleNavigation(option.url)}
                      alignItems={"center"}
                      borderRadius={"16px"}
                      padding={4}
                      bg={
                        option.url === currentPage ? "#456EFF" : "transparent"
                      }
                      _hover={{
                        cursor: "pointer",
                        bg:
                          option.url === currentPage
                            ? "#456EFF"
                            : "transparent",
                      }}
                    >
                      <Image
                        src={
                          option.url == currentPage
                            ? option.activeIcon
                            : option.inactiveIcon
                        }
                        width={"18px"}
                        height={"18px"}
                        marginRight={3}
                      />
                      <Text
                        fontFamily={"PlusJakartaSansSemiBold"}
                        fontSize={"16px"}
                        lineHeight={"20px"}
                        color={
                          option.url === currentPage ? "#FFFFFF" : "#FFFFFF"
                        }
                        textTransform={"capitalize"}
                      >
                        {option.label}
                      </Text>
                    </Flex>
                  </>
                )
              )}
            </>
          )}
          {/* Account Section */}
          <Box
            height="1px"
            bg="#FFFFFF"
            opacity={0.3}
            marginY={4}
            marginX={2}
          />
          {accountOptions.length > 0 && (
            <>
              <Text
                fontFamily={"PlusJakartaSansSemiBold"}
                fontSize={"12px"}
                lineHeight={"16px"}
                color={"#FFFFFF"}
                textTransform={"capitalize"}
                mb={2}
                padding={4}
              >
                Others
              </Text>
              {accountOptions.map((option) => (
                <>
                  <Flex
                    key={option.id}
                    onClick={() => handleNavigation(option.url)}
                    alignItems={"center"}
                    borderRadius={"16px"}
                    padding={4}
                    bg={option.url === currentPage ? "#456EFF" : "transparent"}
                    _hover={{
                      cursor: "pointer",
                      bg:
                        option.url === currentPage ? "#456EFF" : "transparent",
                    }}
                  >
                    <Image
                      src={
                        option.url == currentPage
                          ? option.activeIcon
                          : option.inactiveIcon
                      }
                      width={"18px"}
                      height={"18px"}
                      marginRight={3}
                    />
                    <Text
                      fontFamily={"PlusJakartaSansSemiBold"}
                      fontSize={"16px"}
                      lineHeight={"20px"}
                      color={option.url === currentPage ? "#FFFFFF" : "#FFFFFF"}
                      textTransform={"capitalize"}
                    >
                      {option.label}
                    </Text>
                  </Flex>
                </>
              ))}
            </>
          )}
          {/* <Flex
            alignItems={"center"}
            justifyContent={"space-between"}
            padding={4}
            bg={"black"}
            width={"100%"}
            marginTop={8}
          >
            <Image
              src={require("../../assets/svgs/profile-white.svg").default}
              width={"24px"}
              height={"24px"}
              marginRight={2}
            />
            <Text
              flex={1}
              fontFamily={"PlusJakartaSansSemiBold"}
              fontSize={"16px"}
              lineHeight={"20px"}
              color={"#FFFFFF"}
              textTransform={"capitalize"}
            >
              {user?.info?.first_name + " " + user?.info?.surname}
            </Text>
            <Image
              src={require("../../assets/svgs/logout.svg").default}
              width={"24px"}
              height={"24px"}
              cursor={"pointer"}
              onClick={handleLogout}
            />
          </Flex> */}
        </Flex>
      </Flex>
    </>
  );
};

export default Sidebar;
